module.exports = __webpack_public_path__ + "static/roof_garden01-32181b67bea8cf32007dc51f8c688286.jpg";